import { DropboxFilesListTable } from '@components/display/tables';
import {
    useLazyGetRepairdocDropboxFilesLoadedPathsQuery,
    useRepairdocFavoriteMutation,
    useRepairdocUnfavoriteMutation,
} from '@repairdocs/services';
import { useCallback } from 'react';
import { defineMessage } from 'react-intl';

export const RepairdocsListView = () => {
    const [triggerLoadedPaths] = useLazyGetRepairdocDropboxFilesLoadedPathsQuery();
    const [favoriteFile] = useRepairdocFavoriteMutation();
    const [unfavoriteFile] = useRepairdocUnfavoriteMutation();

    const loadPage = useCallback(
        async ({
            queryPath,
            sortParam,
            pageSize,
            loadedPaths,
        }: {
            queryPath: string;
            sortParam: string | null;
            pageSize: number;
            loadedPaths: string[];
        }) => {
            const pageData = await triggerLoadedPaths(
                {
                    path: queryPath,
                    page_size: pageSize,
                    ordering: sortParam ?? undefined,
                    loaded_paths: loadedPaths,
                },
                true
            ).unwrap();

            return {
                results: pageData.results ?? [],
                count: pageData.count,
            };
        },
        [triggerLoadedPaths]
    );

    const handleFavorite = useCallback(
        async ({ path, folderPath }: { path: string; folderPath: string }) => {
            await favoriteFile({ path, folderPath }).unwrap();
        },
        [favoriteFile]
    );

    const handleUnfavorite = useCallback(
        async ({ path, folderPath }: { path: string; folderPath: string }) => {
            await unfavoriteFile({ path, folderPath }).unwrap();
        },
        [unfavoriteFile]
    );

    return (
        <DropboxFilesListTable
            routeSegment="repairs"
            downloadType="repair_documents"
            emptyListText={defineMessage({
                id: 'repairdocs.emptyList',
                defaultMessage: 'No repair documents found in this folder.',
            })}
            loadErrorMessage={defineMessage({
                id: 'repairdocs.loadError',
                defaultMessage: 'Error loading repair documents',
            })}
            loadPage={loadPage}
            onFavorite={handleFavorite}
            onUnfavorite={handleUnfavorite}
        />
    );
};
